import React, { useEffect, useState } from "react";
import { Box, Dialog, Typography } from "@mui/material";
import InputWithLabel from "../../shared/components/InputWithLabel";
import CustomPrimaryButton from "../../shared/components/CustomPrimaryButton";
import * as api from "../../api";
import { connect } from "react-redux";
import { updateServer } from "../../store/actions/roomActions";

const ChannelSettingsDialog = ({ open, onClose, server, channel, updateServer }) => {
  const [name, setName] = useState("");

  useEffect(() => {
    if (open) setName(channel?.name || "");
  }, [open, channel]);

  const handleSave = async () => {
    const response = await api.updateChannel({ serverId: server.id, channelId: channel.id, name });
    if (!response.error) {
      updateServer(response.data.server);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ sx:{ bgcolor:"#282a30", color:"#f2f3f5", borderRadius:"8px", width:"440px", p:"24px" } }}>
      <Typography sx={{ fontSize:"20px", fontWeight:800 }}>Настройки канала</Typography>
      <InputWithLabel label="Название" value={name} setValue={setName} type="text" placeholder="" />
      <Box sx={{ display:"flex", gap:"12px", mt:"22px" }}>
        <CustomPrimaryButton label="Отмена" onClick={onClose} additionalStyles={{ background:"#4e5058" }} />
        <CustomPrimaryButton label="Сохранить" onClick={handleSave} disabled={name.trim().length < 1} />
      </Box>
    </Dialog>
  );
};

export default connect(null, { updateServer })(ChannelSettingsDialog);
